import React from "react";
import "./oneLineDiagram.css";
import { Stage, Layer, Image, Line, Circle, Text, Rect } from "react-konva";
import useImage from "use-image";
import { useSelector } from "react-redux";

export default function OneLineDiagram({ oneLineRef }) {
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];
  let inverterDetail = [];
  const totalConsumption = roofInfo?.value?.financialAnalysis
    ? roofInfo.value.financialAnalysis.tcy
    : 0;

  let tiltAngle = 10;
  let noOfPanel = 0;
  let totalCapacity = 0;
  let structureFacing = "Azimuth Facing";
  let Azimuth = 180;

  if (roofDetail.roofType === "Shed Roof") {
    tiltAngle = roofDetail.buildingPitch;
  } else if (roofDetail.roofType === "Flat Roof") {
    tiltAngle = 15;
  }

  if (check && quantityInfo.electricalConfiguration === "All Roof") {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      totalCapacity += Number(element.totalKilowatt);
      noOfPanel += element.pvModule;
    }
    inverterDetail = roofInfo.value.inverterAnalysis;
  } else {
    tiltAngle = 10;
    inverterDetail = roofDetail.inverterAnalysis;
    noOfPanel = roofDetail.pvModule;
    totalCapacity = roofDetail.totalKilowatt;
    structureFacing = roofDetail.structureFacing;
    Azimuth = roofDetail.azimuth;
    if (roofDetail.roofType === "Shed Roof") {
      tiltAngle = roofDetail.buildingPitch;
    } else if (roofDetail.roofType === "Flat Roof") {
      tiltAngle = 15;
    }
  }

  const [stringSrc] = useImage("./images/electricalAssets/strings.jpg");
  const [inverterSrc] = useImage("./images/electricalAssets/Inverter.svg");
  const [meter] = useImage("./images/electricalAssets/feedMeter.svg");
  const [meter2] = useImage("./images/electricalAssets/feedMeter2.png");
  const [fixed] = useImage("./images/electricalAssets/fixed.svg");
  const [frame] = useImage("./images/electricalAssets/frame.svg");
  const [grid] = useImage("./images/electricalAssets/Grid.svg");

  return (
    <>
      <div className="oneLineDiagram">
        <div ref={oneLineRef} id="oneLineImage" className="box">
          <Stage
            style={{ cursor: "grab" }}
            width={680}
            height={450}
            fill="ghostwhite"
          >
            <Layer strokeWidth={2}>
              <Rect
                width={360}
                height={210}
                stroke="lightgray"
                strokeWidth={2}
                fill="rgba(230, 230, 230, 0.50)"
                x={12}
                y={5}
              />
              {inverterDetail.totalStringMPPT > 3 && (
                <>
                  <Text
                    x={20}
                    y={14}
                    text={`${structureFacing}`}
                    fontFamily="italic"
                    fontSize={9}
                    fill="black"
                    strokeWidth={2}
                  />
                  <Image image={stringSrc} width={50} x={25} y={24} />
                  <Text
                    x={88}
                    y={24}
                    text={`1x${inverterDetail.noOfStringMPPT}`}
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Line
                    points={[75, 35, 130, 35]}
                    stroke="black"
                    strokeWidth={2}
                    dash={[5, 5]}
                  />
                  <Text
                    x={160}
                    y={42}
                    text={`(1)`}
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={125} y={20} />
                  <Line
                    points={[174, 30, 260, 30]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[260, 30, 260, 80]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[259, 80, 280, 80]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Circle x={280} y={80} radius={4} fill="black" />
                </>
              )}
              {inverterDetail.totalStringMPPT > 0 && (
                <>
                  <Text
                    x={20}
                    y={54}
                    text={`${structureFacing}`}
                    fontFamily="italic"
                    fontSize={9}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={25} y={64} />
                  <Text
                    x={88}
                    y={64}
                    text={
                      inverterDetail.totalStringMPPT <= 2
                        ? `1x${inverterDetail.lastStringMPPT}`
                        : `1x${inverterDetail.noOfStringMPPT}`
                    }
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Line
                    points={[75, 74, 130, 74]}
                    stroke="black"
                    strokeWidth={2}
                    dash={[5, 5]}
                  />
                  <Text
                    x={160}
                    y={87}
                    text={
                      inverterDetail.totalStringMPPT <= 2
                        ? `(1)`
                        : `(${inverterDetail.totalStringMPPT - 2})`
                    }
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={125} y={64} />
                  <Line
                    points={[174, 74, 250, 74]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[250, 74, 250, 90]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[249, 90, 280, 90]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Circle x={280} y={90} radius={4} fill="black" />
                </>
              )}
              {inverterDetail.totalStringMPPT >= 2 && (
                <>
                  <Text
                    x={20}
                    y={110}
                    text={`${structureFacing}`}
                    fontFamily="italic"
                    fontSize={9}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={25} y={120} />
                  <Text
                    x={88}
                    y={120}
                    text={
                      inverterDetail.oneLineMethod !== "strings/MPPT"
                        ? `1x${inverterDetail.noOfStringMPPT}`
                        : `1x${inverterDetail.lastStringMPPT}`
                    }
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Line
                    points={[75, 130, 130, 130]}
                    stroke="black"
                    strokeWidth={2}
                    dash={[5, 5]}
                  />
                  <Text
                    x={160}
                    y={143}
                    text={
                      inverterDetail.totalStringMPPT <= 2
                        ? `(2)`
                        : `(${inverterDetail.totalStringMPPT - 1})`
                    }
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={125} y={120} />

                  <Line
                    points={[174, 130, 250, 130]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[250, 130, 250, 100]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[249, 100, 280, 100]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Circle x={280} y={100} radius={4} fill="black" />
                </>
              )}
              {inverterDetail.totalStringMPPT >= 3 && (
                <>
                  <Text
                    x={20}
                    y={160}
                    text={`${structureFacing}`}
                    fontFamily="italic"
                    fontSize={9}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={25} y={170} />
                  <Text
                    x={88}
                    y={170}
                    text={`1x${inverterDetail.lastStringMPPT}`}
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Line
                    points={[75, 180, 130, 180]}
                    stroke="black"
                    strokeWidth={2}
                    dash={[5, 5]}
                  />
                  <Text
                    x={160}
                    y={193}
                    text={`(${inverterDetail.totalStringMPPT})`}
                    fontFamily="italic"
                    fontSize={10}
                    fill={"black"}
                    strokeWidth={1}
                  />
                  <Image image={stringSrc} width={50} x={125} y={170} />
                  <Line
                    points={[174, 180, 260, 180]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[260, 180, 260, 110]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Line
                    points={[259, 110, 280, 110]}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Circle x={280} y={110} radius={4} fill="black" />
                </>
              )}
            </Layer>
            <Layer>
              {inverterDetail.totalStringMPPT > 4 && (
                <Line
                  points={[100, 40, 100, 64]}
                  stroke="black"
                  strokeWidth={1}
                  dash={[1, 3]}
                />
              )}
              {inverterDetail.noOfInverter > 0 && (
                <>
                  <Image image={inverterSrc} width={50} x={278} y={68} />
                  <Text
                    x={330}
                    y={89}
                    text={`(1)`}
                    fontFamily="italic"
                    fontSize={14}
                    fill={"black"}
                    strokeWidth={1}
                  />
                </>
              )}

              <Line
                points={[371, 95, 620, 95]}
                stroke="black"
                strokeWidth={2}
              />
              {inverterDetail.powerSensor !== "No Power Sensor" && (
                <Image image={meter} width={50} height={70} x={400} y={48} />
              )}
              <Image image={meter2} width={50} height={70} x={480} y={48} />
              <Circle x={465} y={95} radius={6} fill="black" />
              <Image image={fixed} width={50} height={48} x={550} y={70} />
              <Image image={grid} width={50} height={48} x={620} y={70} />
              <Line
                points={[465, 95, 465, 180]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[465, 180, 530, 180]}
                stroke="black"
                strokeWidth={2}
              />
              {inverterDetail.errorShow && (
                <Text
                  x={450}
                  y={230}
                  text={`(${inverterDetail.error})`}
                  fontFamily="italic"
                  fontSize={15}
                  fill={"Red"}
                  strokeWidth={1}
                  width={180}
                />
              )}
              <Image image={frame} width={50} height={48} x={529} y={155} />
              <Text
                x={590}
                y={162}
                text={`Consumption(${totalConsumption}KWh)`}
                fontFamily="italic"
                fontSize={15}
                fill={"black"}
                strokeWidth={1}
                width={85}
              />
            </Layer>

            {inverterDetail.noOfInverter > 1 && (
              <Layer>
                <Rect
                  y={225}
                  width={360}
                  height={220}
                  stroke="lightgray"
                  strokeWidth={2}
                  fill="rgba(230, 230, 230, 0.50)"
                  x={12}
                />
                {inverterDetail.actualString > 3 && (
                  <>
                    <Text
                      x={20}
                      y={230}
                      text={`${structureFacing}`}
                      fontFamily="italic"
                      fontSize={9}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={25} y={240} />
                    <Text
                      x={88}
                      y={240}
                      text={`1x${inverterDetail.actualStringMPPT}`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Line
                      points={[75, 251, 130, 251]}
                      stroke="black"
                      strokeWidth={2}
                      dash={[5, 5]}
                    />
                    <Text
                      x={160}
                      y={262}
                      text={`(1)`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={125} y={240} />
                    <Line
                      points={[174, 250, 260, 250]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[260, 250, 260, 320]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[259, 320, 280, 320]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Circle x={280} y={320} radius={4} fill="black" />
                  </>
                )}
                {inverterDetail.actualString > 0 && (
                  <>
                    <Text
                      x={20}
                      y={280}
                      text={`${structureFacing}`}
                      fontFamily="italic"
                      fontSize={9}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={25} y={290} />
                    <Text
                      x={88}
                      y={290}
                      text={`1x${inverterDetail.actualStringMPPT}`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Line
                      points={[75, 300, 130, 300]}
                      stroke="black"
                      strokeWidth={2}
                      dash={[5, 5]}
                    />
                    <Text
                      x={158}
                      y={313}
                      text={inverterDetail.totalStringMPPT <= 2 ? `(1)` : `(2)`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={125} y={290} />
                    <Line
                      points={[174, 300, 250, 300]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[250, 300, 250, 330]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[249, 330, 280, 330]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Circle x={280} y={330} radius={4} fill="black" />
                  </>
                )}
                {inverterDetail.actualString > 4 && (
                  <Line
                    points={[100, 310, 100, 352]}
                    stroke="black"
                    strokeWidth={1}
                    dash={[1, 3]}
                  />
                )}
                {inverterDetail.actualString >= 2 && (
                  <>
                    <Text
                      x={20}
                      y={350}
                      text={`${structureFacing}`}
                      fontFamily="italic"
                      fontSize={9}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={25} y={360} />
                    <Text
                      x={88}
                      y={360}
                      text={`1x${inverterDetail.actualStringMPPT}`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Line
                      points={[75, 370, 130, 370]}
                      stroke="black"
                      strokeWidth={2}
                      dash={[5, 5]}
                    />
                    <Text
                      x={158}
                      y={383}
                      text={
                        inverterDetail.totalStringMPPT <= 2
                          ? `(2)`
                          : `(${inverterDetail.actualString - 1})`
                      }
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={125} y={360} />

                    <Line
                      points={[174, 370, 250, 370]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[250, 370, 250, 340]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[249, 340, 280, 340]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Circle x={280} y={340} radius={4} fill="black" />
                  </>
                )}
                {inverterDetail.actualString >= 3 && (
                  <>
                    <Text
                      x={20}
                      y={400}
                      text={`${structureFacing}`}
                      fontFamily="italic"
                      fontSize={9}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={25} y={410} />
                    <Text
                      x={88}
                      y={410}
                      text={`1x${inverterDetail.actualStringMPPT}`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Line
                      points={[75, 420, 130, 420]}
                      stroke="black"
                      strokeWidth={2}
                      dash={[5, 5]}
                    />
                    <Text
                      x={160}
                      y={433}
                      text={`(${inverterDetail.actualString})`}
                      fontFamily="italic"
                      fontSize={10}
                      fill={"black"}
                      strokeWidth={1}
                    />
                    <Image image={stringSrc} width={50} x={125} y={410} />
                    <Line
                      points={[174, 420, 260, 420]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[260, 420, 260, 350]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Line
                      points={[259, 350, 280, 350]}
                      stroke="black"
                      strokeWidth={2}
                    />
                    <Circle x={280} y={350} radius={4} fill="black" />
                  </>
                )}
                <Image image={inverterSrc} width={50} x={278} y={308} />
                <Text
                  x={330}
                  y={323}
                  text={
                    inverterDetail.noOfInverter > 2
                      ? `(From 2 to ${inverterDetail.noOfInverter})`
                      : `(${inverterDetail.noOfInverter})`
                  }
                  fontFamily="italic"
                  fontSize={12}
                  width={50}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Line
                  points={[371, 334, 390, 334]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[390, 334, 390, 95]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Circle x={390} y={95} radius={6} fill="black" />
                {inverterDetail.noOfInverter > 1 && (
                  <Line
                    points={[305, 130, 305, 295]}
                    stroke="black"
                    strokeWidth={2}
                    dash={[1, 3]}
                  />
                )}
              </Layer>
            )}
          </Stage>
        </div>

        <div className="symbolBox">
          <div className="container">
            <div className="infoBox">
              <span>{roofData.length > 0 ? noOfPanel : 0} PV Modules</span>
              <span>
                {roofData.length > 0 ? Number(totalCapacity).toFixed(1) : 0} KW
                System Size
              </span>
              <span>
                {Azimuth} {structureFacing}
              </span>
              <span>{tiltAngle} Tilt Angle</span>
              <span>
                {roofDetail.structureType === "Multiple"
                  ? "Mulitple Structure"
                  : roofDetail.mountingStructure}
              </span>
            </div>
            <div className="fixed">
              <span>House Connection</span>
              <img
                src="./images/electricalAssets/fixed.svg"
                alt="inverter"
              ></img>
            </div>
          </div>
          <div className="symbolInfo">
            <span>(1) Inverter</span>
            <img
              src="./images/electricalAssets/Inverter.svg"
              alt="inverter"
            ></img>
            <span>
              {inverterDetail.noOfInverter}x
              {inverterDetail.inverterManufacturer}
            </span>
            <span>{inverterDetail.inverterType}</span>
          </div>
          <div className="symbolInfo">
            <span>(2) PV Module</span>
            <img
              src="./images/electricalAssets//strings.jpg"
              alt="string"
            ></img>
            <span>
              {noOfPanel}x{roofDetail.module}
            </span>
            <span>{roofDetail.moduleType}</span>
          </div>
          <div className="stringDetail">
            <span>{roofDetail.moduleType}</span>
            <div className="stringBox">
              <img
                src="./images/electricalAssets/strings.jpg"
                alt="string"
              ></img>
              <div className="subLine">
                <span>axb</span>
                <span>---------------</span>
              </div>
              <img
                src="./images/electricalAssets/strings.jpg"
                alt="string"
              ></img>
            </div>
          </div>
          <div className="container">
            <div className="symbolInfo">
              <span>(3)Feed in Meter</span>
              <img
                src="./images/electricalAssets/feedMeter2.png"
                alt="inverter"
              ></img>
            </div>
            <div className="symbolInfo">
              <span>(4)Bidirectional Meter</span>
              <img
                src="./images/electricalAssets/feedMeter.svg"
                alt="inverter"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
